import React, { useState,useEffect} from 'react';

const ConatctForm = () => {
  const [formData, setFormData] = useState({
         name: '',
         email: '',
         phone: '',
         message: '',
       });
     
       const [status, setStatus] = useState(null); // for showing success or error messages
       const [isSubmitting, setIsSubmitting] = useState(false); // for showing loading indicator
       const [errors, setErrors] = useState({}); // for showing validation errors
     
       const validateForm = () => {
         const newErrors = {};
         let isValid = true;
     
         // Name validation
         if (!formData.name) {
           newErrors.name = 'Name is required.';
           isValid = false;
         }
     
         // Email validation (basic email format check)
         const emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
         if (!formData.email) {
           newErrors.email = 'Email is required.';
           isValid = false;
         } else if (!emailPattern.test(formData.email)) {
           newErrors.email = 'Please enter a valid email address.';
           isValid = false;
         }
     
         // Phone validation (basic phone number pattern)
         const phonePattern = /^[0-9]{10}$/;
         if (!formData.phone) {
           newErrors.phone = 'Phone number is required.';
           isValid = false;
         } else if (!phonePattern.test(formData.phone)) {
           newErrors.phone = 'Please enter a valid 10-digit phone number.';
           isValid = false;
         }
     
         // Message validation
         if (!formData.message) {
           newErrors.message = 'Message is required.';
           isValid = false;
         }
     
         setErrors(newErrors);
         return isValid;
       };
     
       const handleChange = (e) => {
         const { name, value } = e.target;
         setFormData((prevData) => ({
           ...prevData,
           [name]: value,
         }));
       };
     
       const handleSubmit = async (e) => {
         e.preventDefault();
     
         // Validate form before submitting
         if (!validateForm()) {
           return;
         }
     
         setIsSubmitting(true);
         setStatus(null);
         setErrors({}); // Clear any previous validation errors
     
         try {
           const response = await fetch('https://tech-backend-livid.vercel.app/api/email/', { // Change the URL to your backend endpoint
             method: 'POST',
             headers: {
               'Content-Type': 'application/json',
             },
             body: JSON.stringify(formData),
           });
     
           const data = await response.json();
     
           if (response.ok) {
             setStatus('Email sent successfully!');
           } else {
             setStatus(`Error: ${data.message || 'Failed to send email'}`);
           }
         } catch (error) {
           setStatus('An error occurred while sending the email.');
         } finally {
           setIsSubmitting(false);
         }
       };
    
  return (

    <section className="contact-section text-center py-5">
    <div className="form-container p-5 shadow rounded">
        <h2>Let's Work Together</h2>
        <form onSubmit={handleSubmit}>
            <div className="row">
                <div className="col-md-6 mb-3 formName formContent">
                    <label className="form-label">Name <span className="text-danger">*</span></label>
                    <input
              type="text"
              className="form-control"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            {errors.name && <small className="text-danger">{errors.name}</small>}
                </div>
                <div className="col-md-6 mb-3 formEmail formContent">
                    <label className="form-label">Email <span className="text-danger">*</span></label>
                    <input
              type="email"
              className="form-control"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
            {errors.email && <small className="text-danger">{errors.email}</small>}
                </div>
            </div>
            <div className="mb-3 formNumber formContent">
                <label className="form-label">Contact<span className="text-danger">*</span></label>
                <input
            type="tel"
            className="form-control"
            name="phone"
            placeholder="Enter your phone number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
            </div>
            <div className="mb-3 formMsg formContent">
                <label className="form-label">Message</label>
                <textarea
            className="form-control"
            name="message"
            rows={4}
            placeholder="Type your message here..."
            value={formData.message}
            onChange={handleChange}
          />
          {errors.message && <small className="text-danger">{errors.message}</small>}
            </div>
            <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
          {isSubmitting ? 'Sending...' : 'Submit'}
        </button>
        </form>
        {status && (
        <div className="mt-3">
          <p>{status}</p>
        </div>
      )}
    </div>
</section>
  //   <section className="contact-section text-center py-5">
  //   <div className="form-container p-5 shadow rounded">
  //     <h2>Let's Work Together</h2>
  //     <form onSubmit={handleSubmit}>
  //       <div className="row">
  //         <div className="col-md-6 mb-3">
  //           <label className="form-label">Name <span className="text-danger">*</span></label>
  //           <input
  //             type="text"
  //             className="form-control"
  //             name="name"
  //             placeholder="Enter your name"
  //             value={formData.name}
  //             onChange={handleChange}
  //             required
  //           />
  //           {errors.name && <small className="text-danger">{errors.name}</small>}
  //         </div>
  //         <div className="col-md-6 mb-3">
  //           <label className="form-label">Email <span className="text-danger">*</span></label>
  //           <input
  //             type="email"
  //             className="form-control"
  //             name="email"
  //             placeholder="Enter your email"
  //             value={formData.email}
  //             onChange={handleChange}
  //             required
  //           />
  //           {errors.email && <small className="text-danger">{errors.email}</small>}
  //         </div>
  //       </div>
  //       <div className="mb-3">
  //         <label className="form-label">Phone Number <span className="text-danger">*</span></label>
  //         <input
  //           type="tel"
  //           className="form-control"
  //           name="phone"
  //           placeholder="Enter your phone number"
  //           value={formData.phone}
  //           onChange={handleChange}
  //           required
  //         />
  //         {errors.phone && <small className="text-danger">{errors.phone}</small>}
  //       </div>
  //       <div className="mb-3">
  //         <label className="form-label">Message</label>
  //         <textarea
  //           className="form-control"
  //           name="message"
  //           rows={4}
  //           placeholder="Type your message here..."
  //           value={formData.message}
  //           onChange={handleChange}
  //         />
  //         {errors.message && <small className="text-danger">{errors.message}</small>}
  //       </div>
  //       <button type="submit" className="btn btn-primary w-100" disabled={isSubmitting}>
  //         {isSubmitting ? 'Sending...' : 'Submit'}
  //       </button>
  //     </form>

  //     {status && (
  //       <div className="mt-3">
  //         <p>{status}</p>
  //       </div>
  //     )}
  //   </div>
  // </section>



  
  )
}

export default ConatctForm;